import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "13",
  fill: "none",
  viewBox: "0 0 13 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.493 12.664c3.445 0 6.313-2.86 6.313-6.305S9.93.055 6.486.055C3.047.055.187 2.915.187 6.359c0 3.446 2.868 6.305 6.305 6.305M6.485 1.242A5.1 5.1 0 0 1 11.61 6.36c0 1.235-.43 2.36-1.14 3.235L3.259 2.383c.875-.711 2-1.14 3.226-1.14m.008 10.235a5.087 5.087 0 0 1-5.101-5.118c0-1.226.421-2.351 1.125-3.226l7.203 7.203a5.1 5.1 0 0 1-3.227 1.14"
    }, null, -1)
  ])))
}
export default { render: render }